<template>
  <div style="height: 100%;font-size:14px">
    <div v-if="isTreeBar == 'order'">
      <div style="text-align: right;" @click="isCollapseClick">
        <i class="el-icon-d-arrow-left" style="padding:8px 8px 0 0" v-if="isCollapse"></i>
        <i class="el-icon-d-arrow-right" style="padding:8px 8px 0 0" v-else></i>
      </div>
      <div v-if="isCollapse">
        <el-tree
          :data="data"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expand-all="true"
        ></el-tree>
      </div>
      <div v-else>
        <div>订</div>
        <div>单</div>
        <div>管</div>
        <div>理</div>
      </div>
    </div>
    <div v-if="isTreeBar == 'goods'">
      <div style="text-align: right" @click="isCollapseClick">
        <i class="el-icon-d-arrow-left" style="padding:8px 8px 0 0" v-if="isCollapse"></i>
        <i class="el-icon-d-arrow-right" style="padding:8px 8px 0 0" v-else></i>
      </div>
      <div v-if="isCollapse">
        <div
          :class="[
            'item_text',
            item.type == page_goods_data.flag ? 'action_item' : '',
          ]"
          v-for="item in dataList"
          :key="item.type"
          @click="clickGoodsItem(item.type)"
        >
          {{ item.name }}
        </div>
      </div>
      <div v-else>
        <div>商</div>
        <div>品</div>
        <div>管</div>
        <div>理</div>
      </div>
    </div>
    <div v-if="isTreeBar == 'finance'">
      <div style="text-align: right" @click="isCollapseClick">
        <i class="el-icon-d-arrow-left" style="padding:8px 8px 0 0" v-if="isCollapse"></i>
        <i class="el-icon-d-arrow-right" style="padding:8px 8px 0 0" v-else></i>
      </div>
      <div v-if="isCollapse">
        <div class="item_text" v-for="item in dataList" :key="item">
          {{ item }}
        </div>
      </div>
      <div v-else>
        <div>财</div>
        <div>务</div>
        <div>管</div>
        <div>理</div>
      </div>
    </div>
    <div v-if="isTreeBar == 'logistics'">
      <div style="text-align: right" @click="isCollapseClick">
        <!-- <span>物流管理</span> -->
        <i class="el-icon-d-arrow-left" style="padding:8px 8px 0 0" v-if="isCollapse"></i>
        <i class="el-icon-d-arrow-right" style="padding:8px 8px 0 0" v-else></i>
      </div>
      <div v-if="isCollapse">
        <div class="item_text" v-for="item in dataList" :key="item.type">
          {{ item.name }}
        </div>
      </div>
      <div v-else>
        <div>物</div>
        <div>流</div>
        <div>管</div>
        <div>理</div>
      </div>
    </div>
  </div>
</template>
<script>
let _this;
import { get_order_custom, get_order_org } from "@/request/api/order";
import { get_goods } from "@/request/api/goods";
export default {
  props: ["isTreeBar", "dataList", "page_order_data", "page_goods_data"],
  data() {
    return {
      isCollapse: true,
      data: [
        {
          label: "采购单",
          implement: false,
          children: [
            {
              label: "全部",
              value: "ALL",
              type: "general",
              implement: true,
            },
            {
              label: "待接单",
              value: "WAIT_ORDER_RECEIVING",
              type: "general",
              implement: true,
            },
            {
              label: "待发货",
              value: "WAIT_SEND_GOODS",
              type: "general",
              implement: true,
            },
            {
              label: "待签收",
              value: "WAIT_CONFIRM_SIGNED",
              type: "general",
              implement: true,
            },
            {
              label: "已完成",
              value: "FINISH",
              type: "general",
              implement: true,
            },
            {
              label: "已关闭",
              value: "CLOSED",
              type: "general",
              implement: true,
            },
          ],
        },
        {
          label: "定制单",
          implement: false,
          children: [
            {
              label: "全部",
              value: "ALL",
              type: "custom",
              implement: true,
            },
            {
              label: "待报价",
              value: "WAIT_QUOTE",
              type: "custom",
              implement: true,
            },
            {
              label: "待发货",
              value: "WAIT_SEND_GOODS",
              type: "custom",
              implement: true,
            },
            {
              label: "待签收",
              value: "WAIT_CONFIRM_SIGNED",
              type: "custom",
              implement: true,
            },
            {
              label: "已完成",
              value: "FINISH",
              type: "custom",
              implement: true,
            },
            {
              label: "已关闭",
              value: "CANCEL",
              type: "custom",
              implement: true,
            },
          ],
        },
      ],
      order_status_obj: {},
      defaultProps: {
        children: "children",
        label: "label",
      },
      order_list: {},
    };
  },
  watch: {
    'page_goods_data.baseCategoryId'(){
      _this.get_goods_list(_this.page_goods_data);
    },
    'page_goods_data.flag'(){
      _this.get_goods_list(_this.page_goods_data);
    },
    'page_goods_data.pageNo'(){
      _this.get_goods_list(_this.page_goods_data);
    },
  },
  created() {
    _this = this;
    if (_this.isTreeBar == "order") {//订单管理
      //使用查询订单侧边栏
      _this.get_order(_this.page_order_data); //初始化列表，默认采购单
    } else if (_this.isTreeBar == "goods") {//商品管理
      console.log("这里是商品的侧边栏");
      console.log(_this.page_goods_data);
      _this.get_goods_list(_this.page_goods_data);
    } else if (_this.isTreeBar == "finance") {//财务管理
      console.log("这是财务的");
    }
  },
  methods: {
    clickGoodsItem(e) {
      _this.page_goods_data.flag = e;
      console.log(2222);
    },
    isCollapseClick() {
      _this.isCollapse = !_this.isCollapse;
      if (_this.isCollapse) {
        //打开侧边栏
        _this.$emit("width_change", _this.isCollapse);
      } else {
        // 关闭侧边栏
        _this.$emit("width_change", _this.isCollapse);
      }
    },
    handleNodeClick(data) {
      if (data.implement) {
        _this.page_order_data.order_type = data.type;
        _this.page_order_data.status = data.value;
        _this.page_order_data.pageNo = 1;
        // 点击状态后清空其他
        _this.page_order_data.keyword = "";
        _this.page_order_data.searchType = 1;
        _this.page_order_data.orderDateMin = "";
        _this.page_order_data.orderDateMax = "";
        _this.page_order_data.orderDateType = "";
        _this.page_order_data.timeValue = "不按时间";
        console.log("东北大哥");
        _this.get_order(_this.page_order_data);
        _this.$emit("change", data);
      }
    },
    // 查询商品列表
    get_goods_list(data) {
      console.log("啥意思", data);
      data.isLoading = true
      setTimeout(() => {
        get_goods(data).then((res) => {
        if (res.code == 0) {
          _this.$emit("getGoods", res.data)
        }else{
          _this.$api.e_msg(res.msg)
        }
        data.isLoading = false
        console.log(res);
      });
      }, 800);
      
    },
    // 查询订单
    get_order(data) {
      data.loading_show = true;
      setTimeout(() => {
        if (data.order_type == "custom") {
          // 查询定制单
          get_order_custom(data).then((res) => {
            console.log(res.data);
            _this.order_list = res.data;
            _this.$emit("getOrder", _this.order_list);
          });
        } else {
          // 查询普通订单
          get_order_org(data).then((res) => {
            console.log(res);
            // 处理定制单普通单参数不统一（普通单默认第一个展示出来）
            res.data.records.forEach((item) => {
              _this.$set(item, "imgurl", item.skuList[0].skuImage); //图片地址
              _this.$set(item, "skuName", item.skuList[0].skuName); //规格
              _this.$set(item, "goodsName", item.skuList[0].goodsName); //商品名称
              _this.$set(item, "skuCode", item.skuList[0].skuCode); //sku编码
              _this.$set(item, "costPrice", item.skuList[0].costPrice); //单价
              _this.$set(item, "quantity", item.skuList[0].quantity); //数量
              _this.$set(item, "costTotalFee", item.skuList[0].costTotalFee); //总价
            });
            _this.order_list = res.data;
            _this.$emit("getOrder", _this.order_list);
          });
        }
        data.loading_show = false;
      }, 800);
    },
  },
};
</script>
<style lang="scss" scoped>
.action_item {
  color: #409eff;
}
.bar_box {
  text-align: center;
  height: 100%;
  text-align: center;
}
.item_text {
  text-align: center;
  padding: 4px 0;
  cursor: pointer;
}
</style>